<div>
  <!--begin::Profile Personal Information-->
  <div class="d-flex flex-row">
    <!--begin::Aside-->
    <div
      class="flex-row-auto offcanvas-mobile w-250px w-xxl-300px"
      style="min-height: 700px"
      id="kt_profile_aside"
      *ngIf="client?.id"
    >
      <!--begin::Profile Card-->
      <div class="card card-custom card-stretch panel_1">
        <!--begin::Body-->
        <div class="card-body pt-4">
          <!--begin::User-->
          <div class="mb-5">
            <div style="max-width: 240px; overflow: hidden" class="main-cont">
              <p
                class="font-weight-bolder text-dark-75 title-one"
                *ngIf="!clientForm?.get('is_company').value"
                [innerText]="firstLine()"
              ></p>
              <p
                [innerText]="secondLine()"
                class="font-weight-bolder text-dark-75 title-two"
                *ngIf="!clientForm?.get('is_company').value"
              ></p>
              <p
                class="font-weight-bolder text-dark-75 mb-0"
                *ngIf="clientForm?.get('is_company').value"
                style="font-size: 16px"
              >
                {{ client.first_name ? client.first_name : '' }}
              </p>
              <a class="text-primary">{{ clientForm?.get('is_company').value | clientType }}</a>
            </div>
          </div>
          <!--end::User-->
          <!--begin::Contact-->
          <div class="py-3" style="padding-left: 1.5rem">
            <div
              class="d-flex align-items-center justify-content-left mb-5"
              [matTooltip]="client ? client.email : ''"
            >
              <span class="font-weight-bold mr-2">
                <i class="fa flaticon2-black-back-closed-envelope-shape" aria-hidden="true"></i
              ></span>
              <a class="text-muted text-hover-primary ellipsis">{{ client ? client.email : '' }}</a>
            </div>
            <div
              class="d-flex align-items-center justify-content-left mb-5"
              matTooltip="Cell Phone"
            >
              <span class="font-weight-bold mr-2"> <i class="fas fa-mobile-alt icon-md"></i> </span>
              <a class="text-muted text-hover-primary">{{
                client ? (client.cell_phone | mask : '(000) 000-0000') : ''
              }}</a>
            </div>
            <div
              class="d-flex align-items-center justify-content-left mb-5"
              matTooltip="Office Phone"
            >
              <span class="font-weight-bold mr-2">
                <i class="fa flaticon2-phone" aria-hidden="true"></i>
              </span>
              <a class="text-muted text-hover-primary">{{
                client ? (client.office_phone | mask : '(000) 000-0000') : ''
              }}</a>
            </div>
            <div
              class="d-flex align-items-center justify-content-left mb-5"
              matTooltip="Fax Number"
            >
              <span class="font-weight-bold mr-2">
                <i class="flaticon2-fax icon-md" aria-hidden="true"></i>
              </span>
              <a class="text-muted text-hover-primary">{{
                client ? (client.fax | mask : '(000) 000-0000') : ''
              }}</a>
            </div>
          </div>
          <!--end::Contact-->
        </div>
        <!--end::Body-->
      </div>
      <!--end::Profile Card-->
      <!--begin::Profile Card-->
      <div class="card card-custom card-stretch panel_2">
        <!--begin::Body-->
        <div class="card-body pt-4">
          <!--begin::Nav-->
          <div class="navi navi-bold navi-hover navi-active navi-link-rounded">
            <ng-container
              *ngFor="let tab of tabs"
              [ngTemplateOutlet]="navi_item"
              [ngTemplateOutletContext]="{ tab: tab }"
            ></ng-container>
            <ng-template #navi_item let-tab="tab">
              <div *ngxPermissionsOnly="tab.permission" class="navi-item mb-2 clickable">
                <a
                  class="navi-link py-4"
                  [ngClass]="{ active: tab.active }"
                  (click)="changeTab(tab.index)"
                >
                  <span class="navi-icon mr-2">
                    <i class="{{ tab.icon }}"></i>
                  </span>
                  <span class="navi-text font-size-lg">{{ tab.label }}</span>
                </a>
              </div>
            </ng-template>
          </div>
          <!--end::Nav-->
        </div>
        <!--end::Body-->
      </div>
      <!--end::Profile Card-->
    </div>
    <!--end::Aside-->
    <!--begin::Content-->
    <div
      class="flex-row-fluid"
      [ngStyle]="client?.id ? { 'margin-left': '8px' } : { 'margin-left': '0' }"
      style="min-height: 1200px"
    >
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[0].active">
        <!--begin::Header-->
        <div class="card-header py-3">
          <div class="card-title align-items-start flex-column">
            <h3 class="card-label font-weight-bolder text-dark">
              {{
                client?.id
                  ? (client.first_name ? client.first_name : '') +
                    ' ' +
                    (client.middle_name ? client.middle_name : '') +
                    ' ' +
                    (client.last_name ? client.last_name : '') +
                    ' ' +
                    (client.last_name2 ? client.last_name2 : '') +
                    '’s
              Client Information'
                  : 'New Client'
              }}
            </h3>
            <span class="text-muted font-weight-bold font-size-sm mt-1"
              >{{ client?.id ? 'Update ' : 'Add ' }} client information</span
            >
          </div>
          
          <div class="card-toolbar">
            <a
              ktBackButton
              class="btn btn-secondary mr-2"
              *ngIf="!entity_id"
              mat-raised-button
              matTooltip="Back to the clients list"
            >
              <i class="la la-arrow-left"></i>
              <span class="hidden-mobile" translate="GLOBAL.BACK">Back</span>
            </a>
            <ng-template ngxPermissionsOnly="canEditClient">
              <a
                *ngIf="isViewMode"
                (click)="editClient(client.id)"
                class="btn btn-secondary mr-2"
                mat-raised-button
                matTooltip="Back to the clients list"
              >
                <span class="hidden-mobile" translate="GLOBAL.EDIT">Edit</span>
              </a>
            </ng-template>
            <a
              *ngIf="!isViewMode && client && !client.id"
              href="javascript:;"
              class="btn btn-secondary mr-2"
              (click)="reset()"
              mat-raised-button
              matTooltip="Reset changes"
            >
              <i class="la la-cog"></i>
              <span class="hidden-mobile" translate="GLOBAL.RESET">Reset</span>
            </a>
            <a
              *ngIf="!isViewMode"
              href="javascript:;"
              class="btn btn-primary mr-2"
              color="primary"
              (click)="onSubmit()"
              mat-raised-button
              matTooltip="Save & Continue"
            >
              <span class="hidden-mobile" translate="GLOBAL.SAVE">Save</span>
            </a>
          </div>
        </div>
        <!--end::Header-->

        <!--begin::Form-->
        <form class="form" [formGroup]="clientForm" *ngIf="loadingData">
          <kt-alert
            *ngIf="hasFormErrors"
            type="warn"
            [showCloseButton]="true"
            [duration]="10000"
            (closeAl)="onAlertClose()"
          >
            <span translate="GLOBAL.FORM_ERROR"
              >Oh snap! Change a few things up and try submitting again.</span
            >
          </kt-alert>
          <!--begin::Body-->
          <div class="card-body">
            <div class="row">
              <div class="col-lg-9 col-xl-6">
                <h5 class="font-weight-bold mb-6">Details</h5>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-lg-12 card-header-doctor-form" style="display: flex; flex-wrap: wrap">
                <div class="ml-2 mat-form-field-fluid">
                  <mat-slide-toggle class="mr-2" formControlName="is_company"></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>{{ clientForm?.get('is_company').value | clientType }}</strong>
                  </mat-hint>
                </div>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ clientForm?.get('is_company').value | firstNameToName }}</mat-label>
                  <input matInput placeholder="Enter Name" formControlName="first_name" required />
                  <mat-error
                    >{{ 'PATIENT.INPUT.FIRST_NAME' | translate }}
                    <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div
                *ngIf="!clientForm?.get('is_company').value"
                class="col-lg-4 kt-margin-bottom-20-mobile"
              >
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.MIDDLE_NAME' | translate }}</mat-label>
                  <input matInput placeholder="Enter Middle Name" formControlName="middle_name" />
                </mat-form-field>
              </div>
              <div
                *ngIf="!clientForm?.get('is_company').value"
                class="col-lg-4 kt-margin-bottom-20-mobile"
              >
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.LAST_NAME' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="Enter Last Name"
                    formControlName="last_name"
                    [required]="!clientForm.get('is_company').value"
                  />
                  <mat-error
                    >{{ 'PATIENT.INPUT.LAST_NAME' | translate }}
                    <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div
                *ngIf="!clientForm?.get('is_company').value"
                class="col-lg-4 kt-margin-bottom-20-mobile"
              >
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.LAST_NAME_2' | translate }}</mat-label>
                  <input matInput placeholder="Enter Last Name 2" formControlName="last_name2" />
                </mat-form-field>
              </div>

              <div
                *ngIf="clientForm?.get('is_company').value"
                class="col-lg-4 kt-margin-bottom-20-mobile"
              >
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CLIENT.FORM.DOMAIN">Domain</mat-label>
                  <input matInput formControlName="domain" />
                  <mat-error>
                    Domain is
                    <strong>required</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CLIENT.FORM.EMAIL">Email</mat-label>
                  <input matInput type="email" formControlName="email" />
                  <mat-error *ngIf="isControlHasError('email', 'pattern')">
                    Email is not valid
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CLIENT.FORM.PREFERRED_COMMUNICATION_METHOD"
                    >Preferred Communication Method
                  </mat-label>
                  <mat-select formControlName="communication_method">
                    <mat-option value="EMAIL">{{ 'CLIENT.FORM.EMAIL' | translate }}</mat-option>
                    <mat-option value="FAX">{{ 'CLIENT.FORM.FAX' | translate }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div
                *ngIf="clientForm?.get('is_company').value"
                class="col-lg-4 kt-margin-bottom-20-mobile"
              >
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label>Type</mat-label>
                  <mat-select formControlName="type">
                    <mat-option value="PAYER"> Payer</mat-option>
                    <mat-option value="MANUFACTURER"> Manufacturer</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div
                *ngIf="clientForm?.get('is_company').value"
                class="col-lg-4 kt-margin-bottom-20-mobile"
              ></div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <div class="mat-form-field-fluid">
                  <mat-label class="row ml-1">Client Status</mat-label>
                  <mat-slide-toggle class="mr-2" formControlName="is_active"></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>{{ getStatusString() }}</strong>
                  </mat-hint>
                </div>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <div class="mat-form-field-fluid">
                  <mat-label class="row ml-1">Order Status</mat-label>
                  <mat-slide-toggle
                    class="mr-2"
                    formControlName="order_status_update"
                  ></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>{{ getOrderStatusString() }}</strong>
                  </mat-hint>
                </div>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <div class="mat-form-field-fluid">
                  <mat-label class="row ml-1">Refill Reminder</mat-label>
                  <mat-slide-toggle
                    class="mr-2"
                    formControlName="remind_zero_refill"
                  ></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>{{ getRefillStatusString() }}</strong>
                  </mat-hint>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-9 col-xl-6">
                <h5 class="font-weight-bold mt-10 mb-6">Contacts</h5>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CLIENT.FORM.CELL_PHONE">Cell phone</mat-label>
                  <input
                    matInput
                    type="tel"
                    formControlName="cell_phone"
                    maxlength="14"
                    ktAppPhoneMask
                  />
                  <mat-error *ngIf="isControlHasError('cell_phone', 'pattern')">
                    Cell phone is invalid
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CLIENT.FORM.FAX">Fax</mat-label>
                  <input matInput type="tel" formControlName="fax" maxlength="14" ktAppPhoneMask />
                  <mat-error *ngIf="isControlHasError('fax', 'pattern')">
                    Fax is invalid
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CLIENT.FORM.OFFICE_PHONE">Office Phone</mat-label>
                  <input
                    matInput
                    type="tel"
                    formControlName="office_phone"
                    maxlength="14"
                    ktAppPhoneMask
                  />
                  <mat-error *ngIf="isControlHasError('office_phone', 'pattern')">
                    Office Phone is invalid
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-9 col-xl-6">
                <h5 class="font-weight-bold mt-10 mb-6">Address</h5>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'DOCTOR.INPUT.URBANIZATION' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="urbanization"
                    [ngModel]="urbanizationValue"
                    (ngModelChange)="urbanizationValue = $event ? $event.toUpperCase() : ''"
                  />
                  <mat-error *ngIf="isControlHasError('urbanization', 'maxlength')">
                    Maximum length is 48 character
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.ADDRESS1">Address1</mat-label>
                  <input
                    matInput
                    formControlName="address1"
                    [ngModel]="Address1Value"
                    (ngModelChange)="Address1Value = $event ? $event.toUpperCase() : ''"
                    required
                  />
                  <mat-error *ngIf="isControlHasError('address1', 'maxlength')">
                    Maximum length is 48 character
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('address1', 'required')">
                    Address1 is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.ADDRESS2">Address2</mat-label>
                  <input
                    matInput
                    formControlName="address2"
                    [ngModel]="Address2Value"
                    (ngModelChange)="Address2Value = $event ? $event.toUpperCase() : ''"
                  />
                  <mat-error *ngIf="isControlHasError('address2', 'maxlength')">
                    Maximum length is 48 character
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.CITY">City</mat-label>
                  <input
                    matInput
                    formControlName="city"
                    [ngModel]="cityValue"
                    (ngModelChange)="cityValue = $event ? $event.toUpperCase() : ''"
                    required
                  />
                  <mat-error *ngIf="isControlHasError('city', 'maxlength')">
                    Maximum length is 30 character
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('city', 'required')">
                    City is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.STATE">State</mat-label>
                  <mat-select formControlName="state" required>
                    <mat-option value="AL">AL</mat-option>
                    <mat-option value="AK">AK</mat-option>
                    <mat-option value="AR">AR</mat-option>
                    <mat-option value="AZ">AZ</mat-option>
                    <mat-option value="CA">CA</mat-option>
                    <mat-option value="CO">CO</mat-option>
                    <mat-option value="CT">CT</mat-option>
                    <mat-option value="DC">DC</mat-option>
                    <mat-option value="DE">DE</mat-option>
                    <mat-option value="FL">FL</mat-option>
                    <mat-option value="GA">GA</mat-option>
                    <mat-option value="HI">HI</mat-option>
                    <mat-option value="IA">IA</mat-option>
                    <mat-option value="ID">ID</mat-option>
                    <mat-option value="IL">IL</mat-option>
                    <mat-option value="IN">IN</mat-option>
                    <mat-option value="KS">KS</mat-option>
                    <mat-option value="KY">KY</mat-option>
                    <mat-option value="LA">LA</mat-option>
                    <mat-option value="MA">MA</mat-option>
                    <mat-option value="MD">MD</mat-option>
                    <mat-option value="ME">ME</mat-option>
                    <mat-option value="MI">MI</mat-option>
                    <mat-option value="MN">MN</mat-option>
                    <mat-option value="MO">MO</mat-option>
                    <mat-option value="MS">MS</mat-option>
                    <mat-option value="MT">MT</mat-option>
                    <mat-option value="NC">NC</mat-option>
                    <mat-option value="NE">NE</mat-option>
                    <mat-option value="NH">NH</mat-option>
                    <mat-option value="NJ">NJ</mat-option>
                    <mat-option value="NM">NM</mat-option>
                    <mat-option value="NV">NV</mat-option>
                    <mat-option value="NY">NY</mat-option>
                    <mat-option value="ND">ND</mat-option>
                    <mat-option value="OH">OH</mat-option>
                    <mat-option value="OK">OK</mat-option>
                    <mat-option value="OR">OR</mat-option>
                    <mat-option value="PA">PA</mat-option>
                    <mat-option value="PR">PR</mat-option>
                    <mat-option value="RI">RI</mat-option>
                    <mat-option value="SC">SC</mat-option>
                    <mat-option value="SD">SD</mat-option>
                    <mat-option value="TN">TN</mat-option>
                    <mat-option value="TX">TX</mat-option>
                    <mat-option value="UT">UT</mat-option>
                    <mat-option value="VT">VT</mat-option>
                    <mat-option value="VA">VA</mat-option>
                    <mat-option value="WA">WA</mat-option>
                    <mat-option value="WI">WI</mat-option>
                    <mat-option value="WV">WV</mat-option>
                    <mat-option value="WY">WY</mat-option>
                  </mat-select>
                  <mat-error *ngIf="isControlHasError('state', 'required')">
                    State is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.ZIP">Zip</mat-label>
                  <input
                    matInput
                    formControlName="zip"
                    maxlength="10"
                    [ngModel]="zipValue"
                    (ngModelChange)="zipValue = $event ? putDash($event) : ''"
                    required
                  />
                  <mat-error *ngIf="isControlHasError('zip', 'required')">
                    Zip Code is required
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('zip', 'pattern')">
                    Zip Code is invalid
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-9 col-xl-6">
                <h5 class="font-weight-bold mt-10 mb-6">Other</h5>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CLIENT.FORM.NOTE">Note</mat-label>
                  <textarea matInput rows="7" formControlName="note"></textarea>
                </mat-form-field>
              </div>
            </div>
          </div>
          <!--end::Body-->
        </form>
        <!--end::Form-->
      </div>
      <div class="card card-custom card-stretch" *ngIf="tabs[1].active">
        <div class="until-they">
          <kt-entity-relationships-list
            [entity_type]="'clients'"
            [entity_id]="client?.id"
            (navigateToContact)="closeDialog($event)"
            (openList)="closeDialog($event)"
          ></kt-entity-relationships-list>
        </div>
      </div>
      <div *ngIf="tabs[2].active" class="card card-custom card-stretch">
        <div class="until-they">
          <kt-document-list [entityId]="client?.id"></kt-document-list>
        </div>
      </div>
    </div>
    <!--end::Content-->
  </div>
  <!--end::Profile Personal Information-->
</div>
